import { ElementItemType } from './helper-tooltip.types';

const getPageOffset = (documentPosition: ElementItemType['documentPosition']) => {
  if (documentPosition === 'top' || documentPosition === 'bottom') {
    return window.scrollY;
  }
  if (documentPosition === 'left' || documentPosition === 'right') {
    return window.scrollX;
  }
  return 0;
};

export const calculatePosition = (element: HTMLElement, positionData: ElementItemType) => {
  const { documentPosition, elementDimensions, offset } = positionData;
  let elementPosition = documentPosition
    ? element.getBoundingClientRect()[documentPosition] + getPageOffset(documentPosition)
    : 0;
  if (elementDimensions) {
    elementPosition += elementDimensions === 'halfOfWidth' ? element.clientWidth / 2 : element[elementDimensions];
  }
  return elementPosition + (offset ?? 0);
};
